export default __webpack_public_path__ + "static/media/user_grey.f738da07.svg";